import { AlertTitle, Alert, Typography,Button } from '@mui/material'
import { ArrowDownward as ArrowDownwardIcon } from '@mui/icons-material';

const CustomAlert = ({ title = "", description = "", type = "success", endButtonProps }) => {
  return (
    (<Alert severity={type} sx={{m:1}}>
      <AlertTitle>
        {title}
      </AlertTitle>
      <Typography variant='body2' sx={{
        mb: 1
      }}>
        {description}
      </Typography>
      {endButtonProps && <Button 
         endIcon={ endButtonProps?.endIcon && <ArrowDownwardIcon />}
         variant='outlined' color={type} 
         size='small'
         onClick={()=> typeof endButtonProps?.onClick === "function" ?endButtonProps?.onClick():"" }
         loading={endButtonProps?.loading}
         >
           {endButtonProps?.buttonText}
       </Button>}
    </Alert>)
  );
}

export default CustomAlert